import { render } from "./AApp.vue?vue&type=template&id=6703a048"
import script from "./AApp.vue?vue&type=script&lang=js"
export * from "./AApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__